import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Speakers Directory',
    href: '#'
  }, {
    name: 'Speakers Details',
    href: '#'
  }, {
    name: 'Booking',
    href: '#'
  }, {
    name: 'Blog',
    href: '#'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-88">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-89">
        {/* Logo */}
        <a href="#" className="text-2xl font-heading text-gold-500 tracking-tight" data-id="element-90">
          Goldspeakers
        </a>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center space-x-8" data-id="element-91">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-gold-500 ${isScrolled ? 'text-navy-900' : 'text-navy-900 lg:text-white'}`} data-id="element-92">
              {link.name}
            </a>)}
        </div>

        {/* CTA Button */}
        <div className="hidden lg:block" data-id="element-93">
          <button className="bg-gold-500 hover:bg-gold-400 text-white px-6 py-2.5 rounded-lg font-semibold text-sm transition-colors shadow-sm hover:shadow-md" data-id="element-94">
            Request Speaker Match
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="lg:hidden text-navy-900" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-95">
          {isMobileMenuOpen ? <X size={24} data-id="element-96" /> : <Menu size={24} data-id="element-97" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-98">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-99">
            <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-100">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-navy-900 font-medium hover:text-gold-500" onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
                  {link.name}
                </a>)}
              <button className="bg-gold-500 text-white px-6 py-3 rounded-lg font-semibold text-sm w-full" data-id="element-102">
                Request Speaker Match
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}